/**
 * Short <title> overrides for standalone FAQ pages whose full question is too
 * long for a search-engine title tag (Semrush flags titles over 60 chars).
 * Keyed by FAQ slug; pages not listed keep the full question as the title.
 */
export const FAQ_META_TITLES: Record<string, string> = {
  "are-there-any-long-term-health-effects-associated-with-a-hair-transplant":
    "Long-Term Effects of a Hair Transplant",
  "can-i-speak-with-someone-who-has-had-a-procedure-with-restore":
    "Speak with a RESTORE Patient?",
  "did-your-clinic-perform-hair-transplant-procedures-for-brian-urlacher-and-deion-sanders":
    "Did RESTORE Treat Urlacher & Sanders?",
  "do-i-need-to-do-anything-ahead-of-time-to-prepare-for-my-consultation":
    "How to Prepare for Your Consultation",
  "how-long-does-the-no-shave-fue-hair-transplant-procedure-take":
    "No-Shave FUE Procedure Length",
  "how-long-should-i-wait-between-multiple-hair-transplant-procedures":
    "Waiting Between Hair Transplants",
  "is-hair-restoration-an-affordable-option-for-individuals-with-a-typical-9-to-5-job":
    "Is Hair Restoration Affordable?",
  "is-it-necessary-to-take-medication-long-term-after-a-hair-transplant-procedure":
    "Medication After a Hair Transplant",
  "what-can-i-expect-at-my-free-hair-consultation-with-restore":
    "Your Free RESTORE Consultation",
  "what-is-the-recommended-age-to-consider-a-hair-transplant-procedure":
    "Best Age for a Hair Transplant",
  "what-supplements-or-vitamins-do-you-recommend-to-support-hair-health":
    "Vitamins and Supplements for Hair Health",
  "why-consider-a-hair-transplant-over-non-surgical-options-like-pills-creams-and-shampoos":
    "Transplant vs Pills, Creams and Shampoos",
};
